// extracted by mini-css-extract-plugin
module.exports = {"close":"AlertBanner__close___ChWG_"};